import { useGetStatsQuery } from 'services/statsService';

// Fetches progress stats and exposes each stat group; each is null until the data loads.
export const useProgressStats = () => {
  const { data, isLoading, isError, refetch } = useGetStatsQuery();

  return {
    medicationStats: data?.medication_stats ?? null,
    physicalActivityStats: data?.physical_activity_stats ?? null,
    taskStats: data?.task_stats ?? null,
    isLoading,
    isError,
    refetch,
  };
};
